import { Adb, Directions, Feedback } from '@mui/icons-material';
import { Box, Card, CardContent, IconButton, Popper, Stack, Typography } from '@mui/material';
import React, { useState, useEffect } from 'react';
import MainCard from 'ui-component/cards/MainCard';
import moment from 'moment';

const ItemMensajes = (props) => {
    const { avisos } = props;
    const [anchorEl, setAnchorEl] = useState(null);
    const [mensajes, setMensajes] = useState([
        { title: 'Bienvenido a Universidad Maderas', desc: 'Recibe avisos sobre tus cursos activos y notificaciones de la plataforma' }
    ]);

    const open = Boolean(anchorEl);
    const id = open ? 'simple-popper' : undefined;

    const handleClick = (event) => {
        setAnchorEl(anchorEl ? null : event.currentTarget);
    };

    useEffect(() => {
        if (avisos && avisos.length > 0) {
            const hoy = moment();
            let avisosActual = [];

            avisos.forEach((element) => {
                if (element.date != null) {
                    if (element.periodo && element.periodo == 'ANUAL') {
                        let actual = new Date();
                        let year = actual.getFullYear();
                        let arr = element.date.split('-');
                        let inicio = moment(`${year}-${arr[1]}-${arr[2]}`);

                        if (inicio == hoy) {
                            avisosActual.push(element);
                        }
                    } else {
                        let inicio = moment(element.date);
                        const diferencia = inicio.diff(hoy, 'days');
                        if (element.fechaFin && element.fechaFin != 'NO') {
                            const fin = moment(element.fechaFin);
                            if (hoy >= inicio && hoy <= fin) {
                                avisosActual.push(element);
                            }
                        } else {
                            if (diferencia >= 0 && diferencia <= 3) {
                                avisosActual.push(element);
                            }
                        }
                    }
                }
            });

            if (avisosActual.length > 0) {
                setMensajes([...avisosActual]);
            }
        }
    }, [avisos]);

    return (
        <>
            <IconButton aria-describedby={id} onClick={handleClick} style={{ backgroundColor: '#0D47A1', color: '#FFFFFF' }}>
                <Feedback fontSize="large" />
            </IconButton>

            <Popper Popper id={id} open={open} anchorEl={anchorEl} placement="right" sx={{ zIndex: 3 }}>
                <MainCard border={false} elevation={16} content={false} boxShadow>
                    <Box sx={{ p: 2, overflowY: 'scroll', maxHeight: '300px' }}>
                        {mensajes?.map((av, index) => (
                            <Card key={`av${index}`} variant="outlined" sx={{ m: 1 }}>
                                <CardContent>
                                    <Typography variant="body1">{av.title}</Typography>
                                    <Typography variant="body2">{av.desc}</Typography>
                                </CardContent>
                            </Card>
                            // <Stack key={av.id}>
                            //     <Typography>{av.date}</Typography>
                            //     <Stack direction="column" spacing={0.5} alignItems="flex-start">
                            //         <Typography>{av.title}</Typography>
                            //         <Typography>{av.desc}</Typography>
                            //     </Stack>
                            // </Stack>
                        ))}
                    </Box>
                </MainCard>
            </Popper>
        </>
    );
};

export default ItemMensajes;
